module.exports = __webpack_public_path__ + "img/amt_received.ef907610.svg";